import React from 'react';

import style from './style.module.scss';
import transitionStyle from 'aplazame-design-system/src/scss/transitions.module.scss';


export default function HtmlComponent({
    html,
    type
}) {
    return (
        <div 
            className={`${style.content} ${style[`content--for-${type}`]} ${transitionStyle['child-link-underline-light']}`}
            dangerouslySetInnerHTML={{ __html: html }}
        />
    );
}